module.exports = __webpack_public_path__ + "static/blog-splash-5-2c52428f53fea9841e93d15f3a621a52.jpg";